export default {
  height: 300,
  width: 300,
  link: {}
};
